export default __webpack_public_path__ + "static/media/oops.6085854f.png";